import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import Timelapse from '@material-ui/icons/Timelapse';
import Delete from '@material-ui/icons/Delete';

class Rule extends React.Component {
    state = {
        desde: '',
        hasta: '',
        preparacion: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (props.info && props.id !== state.id) {
            const { id } = props.product;

            const { desde, hasta, preparacion } = props.info;

            state.id = id;
            state.desde = desde ? desde : '';
            state.hasta = hasta ? hasta : '';
            state.preparacion = preparacion ? preparacion : '';

            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value, this.props.index);
    };

    render() {
        const { desde, hasta, preparacion } = this.state;
        return (
            <React.Fragment>
                <Grid
                    item
                    xs={1}
                    className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only center"
                >
                    <Timelapse className={'c_bluish'} />
                </Grid>
                <Grid
                    item
                    xs={4}
                    className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                >
                    <TextField
                        id={'preparacion'}
                        name={'preparacion'}
                        fullWidth
                        className={'flex_full_row'}
                        defaultValue={preparacion}
                        onChange={this.handleChange}
                        margin="normal"
                        type="number"
                    />
                </Grid>
                <Grid
                    item
                    xs={3}
                    className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                >
                    <TextField
                        id={'desde'}
                        name={'desde'}
                        fullWidth
                        className={'flex_full_row'}
                        defaultValue={desde}
                        onChange={this.handleChange}
                        margin="normal"
                        type="number"
                    />
                </Grid>
                <Grid
                    item
                    xs={3}
                    className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                >
                    <TextField
                        id={'hasta'}
                        name={'hasta'}
                        fullWidth
                        className={'flex_full_row'}
                        defaultValue={hasta}
                        onChange={this.handleChange}
                        margin="normal"
                        type="number"
                    />
                </Grid>
                <Grid
                    item
                    xs={1}
                    className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only center"
                >
                    <Delete
                        className={'c_bluish hand'}
                        onClick={(event) => this.props.onDelete(this.props.index)}
                    />
                </Grid>
            </React.Fragment>
        );
    }
}

Rule.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Rule);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/recipe/Rule.js